module.exports = "/images/sorting-asc.svg?bc6327abc8d9c57e393b9d910dbb175e";